/* Progressive enhancement of Shopify's native dialog; keeps its inputs and handlers. */
(function () {
  "use strict";
  if (window.ggCookiePanelReady) return;
  window.ggCookiePanelReady = true;
  var locale = (document.documentElement.lang || "pl").split("-")[0];
  var data;
  try {
    data = JSON.parse(document.querySelector("[data-gg-cookie-catalog]").textContent);
    if (!Array.isArray(data.cookies) || !data.labels) throw new Error("catalog_invalid");
  } catch (_) {
    // Preserve working consent controls, but never silently present a missing inventory as complete.
    var errors = {
      pl: "Nie udało się wczytać listy cookies. Natywne ustawienia zgód nadal działają.",
      en: "The cookie list could not be loaded. Native consent settings still work.",
      de: "Die Cookie-Liste konnte nicht geladen werden. Die nativen Einwilligungseinstellungen funktionieren weiterhin.",
    };
    function warn() {
      var body = document.querySelector("#shopify-pc__prefs .shopify-pc__prefs__intro");
      if (!body || body.querySelector("[data-gg-inventory-error]")) return;
      var message = document.createElement("p");
      message.setAttribute("data-gg-inventory-error", "");
      message.setAttribute("role", "status");
      message.textContent = errors[locale] || errors.en;
      body.appendChild(message);
    }
    new MutationObserver(warn).observe(document.body, {childList: true, subtree: true});
    warn();
    return;
  }
  if (!data.labels[locale]) locale = "en";
  var copy = data.labels[locale];

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function duration(seconds) {
    if (seconds === null) return copy.session;
    var unit = seconds >= 86400 ? "day" : "minute";
    var value = Math.ceil(seconds / (unit === "day" ? 86400 : 60));
    return copy.upTo + " " + new Intl.NumberFormat(locale, {
      style: "unit", unit: unit, unitDisplay: "long",
    }).format(value);
  }

  function cookieList(cookies) {
    var list = element("ul", "gg-cp__cookies");
    cookies.forEach(function (cookie) {
      var item = element("li", "gg-cp__cookie");
      item.appendChild(element("code", "gg-cp__cookie-name", cookie.name));
      item.appendChild(element("p", "gg-cp__purpose", cookie.purpose[locale]));
      var fields = element("dl", "gg-cp__metadata");
      [[copy.provider, cookie.provider], [copy.domain, cookie.domain],
        [copy.duration, duration(cookie.seconds)]].forEach(function (field) {
        var pair = element("div");
        pair.appendChild(element("dt", "", field[0]));
        pair.appendChild(element("dd", "", field[1]));
        fields.appendChild(pair);
      });
      item.appendChild(fields);
      list.appendChild(item);
    });
    return list;
  }

  function category(option, key) {
    var label = option.querySelector("label");
    var input = option.querySelector("input");
    var description = option.querySelector("p");
    if (!label || !input || !description) return;
    var title = label.textContent.trim();
    var cookies = data.cookies.filter(function (cookie) { return cookie.category === key; });
    var heading = element("div", "gg-cp__category-heading");
    var disclosure = element("button", "gg-cp__disclosure");
    disclosure.type = "button";
    disclosure.id = "gg-cp-disclosure-" + key;
    disclosure.setAttribute("aria-expanded", "false");
    disclosure.setAttribute("aria-controls", "gg-cp-details-" + key);
    var text = element("span", "gg-cp__category-title", title);
    if (cookies.length) text.appendChild(element("span", "gg-cp__count",
      cookies.length + " " + copy.items + (key === "essential" ? " · " + copy.alwaysOn : "")));
    disclosure.appendChild(text);
    disclosure.appendChild(element("span", "gg-cp__chevron", "+"));
    var details = element("div", "gg-cp__details");
    details.id = "gg-cp-details-" + key;
    details.hidden = true;
    details.setAttribute("role", "region");
    details.setAttribute("aria-labelledby", disclosure.id);
    details.appendChild(description);
    if (cookies.length) details.appendChild(cookieList(cookies));
    disclosure.addEventListener("click", function (event) {
      event.stopPropagation();
      var expanded = disclosure.getAttribute("aria-expanded") === "true";
      disclosure.setAttribute("aria-expanded", String(!expanded));
      details.hidden = expanded;
      disclosure.lastElementChild.textContent = expanded ? "+" : "−";
    });
    // Preserve the original accessible label and checkbox; only their presentation changes.
    label.classList.add("gg-cp__switch");
    Array.from(label.childNodes).forEach(function (node) {
      if (node.nodeType !== 3 || !node.textContent.trim()) return;
      var hidden = element("span", "gg-cp__input-label", node.textContent);
      label.replaceChild(hidden, node);
    });
    label.appendChild(element("span", "gg-cp__track"));
    label.lastElementChild.setAttribute("aria-hidden", "true");
    if (key === "essential") {
      input.disabled = true;
      label.title = copy.alwaysOn;
    }
    heading.appendChild(disclosure);
    heading.appendChild(label);
    option.appendChild(heading);
    option.appendChild(details);
    option.classList.add("gg-cp__category");
  }

  function enhance() {
    var dialog = document.getElementById("shopify-pc__prefs__dialog");
    if (!dialog || dialog.classList.contains("gg-cookie-panel")) return;
    var actions = dialog.querySelector(".shopify-pc__prefs__header-actions");
    var scroll = dialog.querySelector(".shopify-pc__prefs__scrollable");
    var options = ["essential", "preferences", "marketing", "analytics"].map(function (key) {
      return dialog.querySelector("#shopify-pc__prefs__" + key);
    });
    // A changed Shopify DOM must not leave a half-rebuilt modal.
    if (!actions || !scroll || options.some(function (option) {
      return !option || !option.querySelector("label") || !option.querySelector("input") || !option.querySelector("p");
    })) return;
    options.forEach(function (option, index) {
      category(option, ["essential", "preferences", "marketing", "analytics"][index]);
    });
    var footer = element("footer", "gg-cp__footer");
    footer.appendChild(actions); // Move nodes, never clone or replace Shopify's consent handlers.
    dialog.appendChild(footer);
    dialog.classList.add("gg-cookie-panel");
  }

  // Shopify re-creates the preferences DOM on reopen; enhance each new instance.
  var scheduled = false;
  new MutationObserver(function (changes) {
    if (scheduled || !changes.some(function (change) { return change.addedNodes.length; })) return;
    scheduled = true;
    window.requestAnimationFrame(function () { scheduled = false; enhance(); });
  }).observe(document.body, {childList: true, subtree: true});
  enhance();

  // Reordered native buttons require focus order to follow the displayed DOM.
  document.addEventListener("keydown", function (event) {
    if (event.key !== "Tab") return;
    var dialog = document.querySelector("#shopify-pc__prefs__dialog.gg-cookie-panel");
    if (!dialog || !dialog.getClientRects().length) return;
    var focusable = Array.from(dialog.querySelectorAll(
      'button:not(:disabled), input:not(:disabled), a[href], [tabindex]:not([tabindex="-1"])'
    )).filter(function (node) { return node.tabIndex >= 0 && node.getClientRects().length; });
    if (!focusable.length) return;
    var index = focusable.indexOf(document.activeElement);
    var next = index < 0 ? (event.shiftKey ? focusable.length - 1 : 0) :
      (index + (event.shiftKey ? -1 : 1) + focusable.length) % focusable.length;
    event.preventDefault();
    event.stopImmediatePropagation();
    focusable[next].focus();
  }, true);
})();
